'use client';
import { jsx } from 'react/jsx-runtime';
import { useMenuItem } from '@react-aria/menu';
import { useRef, useEffect } from 'react';
import { useTrackDisabledState } from '../../contexts/internal/collection/collection.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const MenuItemInternal = ({ item: c, state: l })=>{
    var a;
    let u = useRef(null), p = null !== (a = c.props) && void 0 !== a ? a : {}, { disabled: s, href: f, textValue: b } = p, m = _object_without_properties(p, [
        "disabled",
        "href",
        "textValue"
    ]);
    useTrackDisabledState(c.key, s);
    let { menuItemProps: d, isFocusVisible: _ } = useMenuItem({
        key: c.key
    }, l, u);
    useEffect(()=>{
        var e;
        null === (e = u.current) || void 0 === e || e.addEventListener('touchend', (e)=>{
            e.preventDefault();
        }, {
            passive: false,
            once: true
        });
    }, []);
    let y = new Set([
        'swan-menu-item',
        'swan-listbox-option'
    ]);
    return _ && y.add('swan-menu-item-focused swan-listbox-option-focused'), jsx(RenderComp, {
        root: f ? 'a' : 'li',
        forwardedRef: u,
        props: _object_spread({
            href: f
        }, m, d),
        classNames: y,
        children: c.rendered
    });
};

export { MenuItemInternal };
